import React from "react";

const StyledH4Heading = ({ children, font }) => {
  return (
    <h4 className={`text-h4 font-star-jedi lowercase ${font}`}>{children}</h4>
  );
};

export default StyledH4Heading;
